import { createTheme, ThemeProvider } from "@mui/material/styles";
import Routing from "./routes/routing";
import "./App.css";
import { setupAuth } from "./utils/authSetup";

setupAuth();

const theme = createTheme({
  typography: {
    fontFamily: '"Gotham", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": { fontFamily: '"Gotham", sans-serif' },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Routing />
    </ThemeProvider>
  );
}

export default App;
